import React from "react";

export default function Header() {
  return (
    <header data-aos="fade-left">
      <div className="flex__container">
          <div className="about">
            <p >Hello, I'm Tobi.</p>
            <p >A full-stack developer</p>
          </div>
      </div>
     
    </header>
  );
}
